<template>
  <div class="app-footer">
    <div class="logo">
      <div class="logo-cover">
        <img src="@/assets/images/logo.png" alt="logo" />
      </div>
    </div>
    <ul class="links">
      <li class="link">
        <vs-button icon href="files/resume.pdf" target="_blank">
          <i class="bx bx-file-blank"></i>
        </vs-button>
        <div class="text">
          Resume
        </div>
      </li>
      <li class="link">
        <vs-button icon :href="getEmail">
          <i class="bx bx-envelope"></i>
        </vs-button>
        <div class="text">
          {{ email }}
        </div>
      </li>
      <li class="link">
        <vs-button icon :href="getLinkedIn">
          <i class="bx bxl-linkedin"></i>
        </vs-button>
        <div class="text">
          {{ linkedin }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      email: "shahrozsaleem17@gmail.com",
      linkedin: "linkedin.com/in/shahroz-saleem",
      linkedinUrl: "http://linkedin.com/in/shahroz-saleem"
    };
  },
  computed: {
    getEmail() {
      return "mailto:" + this.email;
    },
    getLinkedIn() {
      return this.linkedinUrl;
    }
  }
};
</script>

<style scoped>
.app-footer {
  position: relative;
  background: #f7f7f7;
  padding: 1em 5vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.logo-cover {
  width: 70px;
  height: 70px;
}

.logo-cover img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.links {
  list-style-type: none;
  width: 100%;
  margin: 0px;
  padding: 0px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.link {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px;
}

.text {
  letter-spacing: 1.5px;
  margin-left: 0.5em;
}
</style>
